import PropTypes from 'prop-types';
// styles
import styled from 'styled-components';
// logic
import { getContainerData } from './LoadsSummaryTableTenant';

const LoadsSummaryInlineTenant = ({ className, order }) => {
  const stops = order.stops;
  const containerData = getContainerData(stops);

  const isPlural = containerData.numberOfContainers !== 1;

  return (
    <div className={className}>
      Envío de {containerData.numberOfContainers}{' '}
      {isPlural ? 'contenedores' : 'contenedor'}
    </div>
  );
};

LoadsSummaryInlineTenant.propTypes = {
  className: PropTypes.string,
  order: PropTypes.object.isRequired,
};

export default styled(LoadsSummaryInlineTenant)`
  margin-top: 16px;
  color: var(--grey700);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
`;
